import { render, staticRenderFns } from "./admin-notification-dialog.vue?vue&type=template&id=873ad8e4&scoped=true"
import script from "./admin-notification-dialog.vue?vue&type=script&lang=js"
export * from "./admin-notification-dialog.vue?vue&type=script&lang=js"
import style0 from "./admin-notification-dialog.vue?vue&type=style&index=0&id=873ad8e4&prod&scoped=true&lang=css"
import style1 from "./admin-notification-dialog.vue?vue&type=style&index=1&id=873ad8e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "873ad8e4",
  null
  
)

export default component.exports